<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router';
import type { ResolvedMonospaceCollection } from '#layers/data-model/public';
import { computed } from 'vue';
import { useAppConfig } from '#app/config';
import { DetailPageDismissAction } from '#layers/block-engine/public';
import { useDataModelDisplayNames } from '#layers/data-model/public';
import { useCollectionRoutes } from '#layers/spaces/public';
import { RenderPageActions } from '#layers/ui/public';

const {
	collection,
	backRoute: backRouteProp,
} = defineProps<{
	collection: ResolvedMonospaceCollection;
	backRoute?: RouteLocationRaw;
	dismissAction?: DetailPageDismissAction;
}>();

const appConfig = useAppConfig();
const { listingRoute } = useCollectionRoutes(() => collection);
const backRoute = computed(() => backRouteProp ?? listingRoute.value);
const { getCollectionDisplayName } = useDataModelDisplayNames();
</script>

<template>
	<DSecondaryHeader bar class="relative ps-3">
		<DTooltip v-if="dismissAction === DetailPageDismissAction.Close" :text="$t('common.close')">
			<DButton
				icon="lucide:x"
				color="neutral"
				variant="ghost"
				size="sm"
				square
				:to="backRoute"
				:aria-label="$t('common.close')"
			/>
		</DTooltip>

		<DButton
			v-else
			:icon="appConfig.ui.icons.back"
			color="neutral"
			variant="ghost"
			size="sm"
			:to="backRoute"
			class="truncate"
		>
			{{ $t('common.back_to', { name: getCollectionDisplayName(collection) }) }}
		</DButton>
		<template #actions>
			<RenderPageActions />
		</template>
	</DSecondaryHeader>
</template>
